export const GETCOMPANY = "GETCOMPANY";
export const EDITCOMPANY = "EDITCOMPANY";

export const GETCOMPANYSAGA = "GETCOMPANYSAGA";
export const EDITCOMPANYSAGA = "EDITCOMPANYSAGA";

export const GETRESPONSIBLES = "GETRESPONSIBLES";
export const GETRESPONSIBLESSAGA = "GETRESPONSIBLESSAGA";
